import React from 'react';
import { useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';

import { useHealthQuoteFetch } from '../hook';
import { healthQuoteCustom, HealthQuoteCustomPayload } from '../action';
import { RightCol } from '../right-col';
import HealthQuoteBuyCustomForm, { FormValues } from '../HealthQuoteBuyCustomForm';
import { useInitialValues } from './hook';

const HealthQuoteBuyCustomPage = () => {
  const dispatch = useDispatch();
  const healthQuote = useHealthQuoteFetch();
  const initialValues = useInitialValues();

  if (isUndefined(healthQuote)) return <Loading />;
  if (isNull(healthQuote)) return <LoadingError />;
  if (!initialValues) return null;

  const { orderNumber, healthPlanName } = healthQuote;

  const handleSubmit = (values: FormValues) => {
    const payload: HealthQuoteCustomPayload = { ...values, orderNumber };
    dispatch(healthQuoteCustom(payload));
  };

  return (
    <Container className="my-3">
      <Row className="gy-5">
        <Col lg={8}>
          <HealthQuoteBuyCustomForm initialValues={initialValues} onSubmit={handleSubmit} />
        </Col>
        <RightCol {...healthQuote} planName={healthPlanName} />
      </Row>
    </Container>
  );
};

export { HealthQuoteBuyCustomPage };
